module.exports = __webpack_public_path__ + "img/dach.ae01576f.jpg";